import React from 'react'

const TODO = (props) => {
  const red = <span class="inline-flex items-center gap-x-1.5 my-2 py-1 px-3 rounded-lg text-xs font-medium bg-red-100 text-red-800 dark:bg-red-800/30 dark:text-red-500">Refactoring</span>
  const any = <span class="inline-flex items-center gap-x-1.5 my-2 py-1 px-3 rounded-lg text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-800/30 dark:text-yellow-500">Refactoring</span>
 
  
  return (
    <div>
        <div className="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-slate-900 dark:border-gray-700 dark:shadow-slate-700/[.7] m-3">
            <div className=" md:p-5 p-20">
              
              <p className="mt-2 text-gray-800 font-medium dark:text-gray-400">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla imperdiet lorem sit amet diam porta fringilla. Integer nec diam elit. Ut feugiat consequat massa, ut posuere tellus. Quisque eget augue dui.
              </p>
              
              {props.isTaske ? red : any}
              
            </div>
            <div className="bg-gray-50 border-t rounded-b-xl py-3 px-4 md:py-4 md:px-5 dark:bg-slate-900 dark:border-gray-700">
              <div className='grid grid-cols-2 gap-[340px]'>
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-500 w-80">
                Last updated 5 mins ago
              </p>
              <span className="inline-flex items-center justify-center size-[46px] text-sm font-semibold leading-none rounded-full bg-teal-100 text-teal-800 dark:bg-teal-800/30 dark:text-teal-500">
                {props.name}
            </span>
              </div>
            </div>
          </div>
    </div>
  )
}

export default TODO